export const boolean = [
	{ label: 'Yes', value: '1' },
	{ label: 'No', value: '0' },
];
